export const environment = {
  UserGuideUrl:
    'https://elearning.easygenerator.com/50b37866-2ea5-47a5-b72f-12c158f7459f/',
  UserGuideSnapshotUrl:
    'https://elearning.easygenerator.com/4168a9e6-5f42-4a18-80cd-5aeab0add565/',
  askMePythonUrl: 'https://askmepreprod-h7c5fdfkesdudfh0.northeurope-01.azurewebsites.net/',
  baseApiUrl: 'https://de-devclient.azurewebsites.net/',
  kantarClientID: '67585151-0ed7-4b89-9694-ffeea52a5244',
  kantarApiClientID: '8f9ba22f-647d-4381-a30d-f09c90bfea96',
  kantarAuthorityID:
    'https://login.microsoftonline.com/1e355c04-e0a4-42ed-8e2d-7351591f0ef1',
  //redirectUrl: 'http://localhost:4200/landing',
  redirectUrl: 'https://dataexplorer-preprod.kantar.com/landing',
  // baseApiUrl: 'https://kapdashboardapidev.azurewebsites.net/',
  logoutURL: 'https://dataexplorer-preprod.kantar.com/signout-oidc',
  baseUrl: '/',
  sessionTimeOut: 60,
  env: 'preprod',
  showUploadModule: true,
  dedicatedCss: false,
};
